export interface DiasInhabilesTranslations {
  TABLE: {
      DESCRIPCION: string;
      FECHA: string;
      ACTIONS: string;
  };
  [key: string]: any;
}

export const diasInhabilesTranslations: { [language: string]: DiasInhabilesTranslations } = {
    en: {
        TABLE: {
            DESCRIPCION: "Description",
            FECHA: "Date",
            ACTIONS: "Actions",
        },
    },
    es: {
        TABLE: {
            DESCRIPCION: "Descripción",
            FECHA: "Fecha",
            ACTIONS: "Acciones",
        },
    }
};
